import toast from 'react-hot-toast';
import { dismissibleToast } from '../utils/dismissibleToast';

const retry = (failureCount, error: any) => error?.response?.status !== 404 && error?.response?.status !== 401;

const queryDefaults = { retry };

export default queryDefaults;
